import React from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import QuotePdfDocument from './QuotePdfDocument';

export default function QuotesPreview({ draftQuote, onBack }) {
  if (!draftQuote) {
    return (
      <div className="flex flex-col h-full bg-gray-100 font-[Arial,sans-serif]">
        <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200">
          <button type="button" onClick={onBack} className="bg-transparent border-none text-2xl cursor-pointer text-gray-700 px-1" aria-label="Close">×</button>
          <h1 className="m-0 text-lg font-bold text-gray-900">Quote preview</h1>
        </div>
        <div className="p-6">
          <p>No draft quote found. Go back and click Preview again.</p>
        </div>
      </div>
    );
  }

  const fileName = `quote-${draftQuote.formData?.quotation_number || 'draft'}.pdf`;

  return (
    <div className="flex flex-col h-full bg-gray-100 font-[Arial,sans-serif]">
      <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200">
        <button type="button" onClick={onBack} className="bg-transparent border-none text-2xl cursor-pointer text-gray-700 px-1" aria-label="Close">×</button>
        <h1 className="m-0 text-lg font-bold text-gray-900">Quote preview</h1>
        <div className="ml-auto flex items-center gap-3">
          <PDFDownloadLink
            document={<QuotePdfDocument draftQuote={draftQuote} />}
            fileName={fileName}
            className="px-4 py-2 bg-blue-600 text-white rounded-md font-semibold text-sm no-underline hover:bg-blue-700 transition-colors"
          >
            {({ loading }) => (loading ? 'Preparing...' : 'Download PDF')}
          </PDFDownloadLink>
          <button type="button" className="bg-transparent border-none text-lg cursor-pointer text-gray-500" aria-label="More options">⋮</button>
        </div>
      </div>

      <div className="flex-1 min-h-0 flex flex-col">
        <PDFViewer className="flex-1 w-full min-h-[400px] border-none" showToolbar>
          <QuotePdfDocument draftQuote={draftQuote} />
        </PDFViewer>
      </div>
    </div>
  );
}
